const CustomTicketsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    fill="none"
    viewBox="0 0 21 21"
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.583 13.833h-6.25A.833.833 0 0 1 .5 13v-2.526a.416.416 0 0 1 .364-.417 2.917 2.917 0 0 0 0-5.788.42.42 0 0 1-.364-.417V1.334A.833.833 0 0 1 1.333.5h17.5a.833.833 0 0 1 .834.833V3.86a.417.417 0 0 1-.365.417 2.916 2.916 0 0 0-2.52 3.326"
    ></path>
    <path
      stroke="#000"
      d="M13.416 2.792a.208.208 0 0 1 0-.417M13.416 2.792a.208.208 0 1 0 0-.417M13.416 5.292a.208.208 0 0 1 0-.417M13.416 5.292a.208.208 0 1 0 0-.417"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.839 13.803a1.198 1.198 0 1 0 2.397 0 1.198 1.198 0 0 0-2.397 0"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15.055 8.336.353 1.16a.79.79 0 0 0 .938.544l1.175-.273a1.07 1.07 0 0 1 1.018 1.772l-.823.886a.8.8 0 0 0 0 1.084l.822.887a1.07 1.07 0 0 1-1.017 1.772l-1.176-.272a.79.79 0 0 0-.937.544l-.353 1.16a1.063 1.063 0 0 1-2.035 0l-.354-1.155a.79.79 0 0 0-.937-.544l-1.176.273a1.07 1.07 0 0 1-1.016-1.772l.821-.887a.8.8 0 0 0 0-1.084l-.821-.887a1.07 1.07 0 0 1 1.016-1.772l1.176.273a.794.794 0 0 0 .938-.544l.353-1.16a1.063 1.063 0 0 1 2.035-.005"
    ></path>
  </svg>
);

export default CustomTicketsIcon;
